module.exports = __webpack_public_path__ + "static/img/V5.6cc06cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/V5.png
// module id = ENZx
// module chunks = 1